import React from 'react'
import { MdOutlineMail } from "react-icons/md";
import { TbWorld } from "react-icons/tb";
import { FaPhoneAlt } from "react-icons/fa";

function Contact() {
  return (
    <>
      <div class="container flex flex-wrap justify-center items-center h-auto  xl:p-5">
  {/* <!-- Contact Info Section --> */}
  <div class="w-full md:w-2/4 p-4">
    <h2 class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-5xl mb-2 font-semibold  text-transparent bg-clip-text bg-gradient-to-r from-black to-[#e710ea]">
      GET IN TOUCH!
    </h2>

    <div class="max-w-full mx-auto rounded-lg overflow-hidden">
      {/* <!-- Address Section --> */}
      <div class=" py-4">
        <h3 class="text-2xl font-medium text-gray-900 mb-2">Our Address</h3>
        <p class="text-lg leading-relaxed">
          Shop No: G-02, Apurwa Apartment, Nara Road, <br />
          Beside Jaripatka Police Station, <br />
          Jaripatka, Nagpur-440014
        </p>
      </div>
      <hr></hr>
      {/* <!-- Working Hours Section --> */}
      <div class=" py-4">
        <h3 class="text-2xl font-medium text-gray-900 mb-2">Working Hours</h3>
        <p class="mt-1 text-gray-600 text-lg">Monday - Saturday: 10:30 AM - 6:30 PM</p>
        <p class="mt-1 text-gray-600 text-lg">Sunday: Closed</p>
      </div>
      <hr></hr>
      <div className="w-full space-y-6 mt-4 text-gray-800">
      {/* Mr. Vijendra Shukla */}
      <div className="text-base sm:text-lg xl:text-xl">
        <p className="font-semibold text-gray-700">Mr. Vijendra Shukla (Marketing Head)</p>
        <div className="flex items-center gap-2 mt-1 text-[#e710ea]">
          <FaPhoneAlt className="text-sm" />
          <span>+91-90284-42756, 95183-11304</span>
        </div>
      </div>

      {/* For Support */}
      <div className="text-base sm:text-lg xl:text-xl">
        <p className="font-semibold text-gray-700">For Support</p>
        <div className="flex items-center gap-2 mt-1 text-[#e710ea]">
          <FaPhoneAlt className="text-sm" />
          <span>+91 98818 20826</span>
        </div>
        <div className="flex items-center gap-2 mt-1 text-gray-700">
          <TbWorld className="text-xl" />
          <span>bulksmsnagpur.co.in</span>
        </div>
      </div>

      {/* Back Office */}
      <div className="text-base sm:text-lg xl:text-xl">
        <p className="font-semibold text-gray-700">Back Office</p>
        <div className="flex items-center gap-2 mt-1 text-[#e710ea]">
          <FaPhoneAlt className="text-sm" />
          <span>+91 7020 962381</span>
        </div>
        <div className="flex items-center gap-2 mt-1 text-gray-700">
          <MdOutlineMail className="text-xl" />
          <span>bulksmsnagpur@gmail.com</span>
        </div>
      </div>
    </div>

      <p class="text-xl font-semibold mt-4">
        Let's connect and discuss how we can help grow your business with our services.
      </p>
    </div>
  </div>

  {/* <!-- Map Section --> */}
  <div class="w-full md:w-1/2 flex justify-center">
    <div class="overflow-hidden w-full sm:w-[25rem] md:w-[30rem] lg:w-[35rem] h-[25rem] md:h-[30rem] lg:h-[35rem]">
      <iframe
        class="w-full h-full"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7537.64532235394!2d79.08540639493006!3d21.189624549872796!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c13ed9043f49%3A0x6419e88ae251d3ac!2sJaripatka%20Police%20Station!5e0!3m2!1sen!2sus!4v1729615999496!5m2!1sen!2sus"
        frameBorder="0"
        allowFullScreen=""
        aria-hidden="false"
        tabIndex="0"
      ></iframe>
    </div>
  </div>
</div>

      
    </>
  )
}

export default Contact
